import React from 'react';

import { CircleCheckIcon } from 'lucide-react';

export const SatisfiedRequirementIcon: React.FC = () => (
  <CircleCheckIcon className="inline-block size-4 text-success" />
);
